import { memo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Box, useTheme } from '@mui/material'

import Popup from '../../shared/popup/Popup'
import { ONYX_LEVEL_ID } from '../../../util/staking/staking.helpers'
import StatusUpgradeList from '../../shared/purchaseStatus/StatusUpgradeList'
import PurchaseStatusReq from '../../shared/purchaseStatus/PurchaseStatusReq'
import CustomAlert from '../../shared/customAlert/CustomAlert'
import Text from '../../shared/text/Text'
import { THEME_MODE } from '../../../constants/theme'

const PurchaseStatus = ({
  symbol,
  onSubmit,
  onCancel,
  mainProfile: { tiers, userTier },
  onPurchase,
  purchaseTierProfile: { isProcessing, error },
  tiersForPurchase
}) => {
  const theme = useTheme()
  const reqTierNotMet = userTier.tier.id < ONYX_LEVEL_ID
  const { t } = useTranslation()
  const { tiers: tiersPurchase, noPoints } = tiersForPurchase
  const isError = error?.purchaseWithPoints
  return (
    <Popup
      title={t('membership.purchase-status-title')}
      description={t('membership.purchase-status-desc')}
      submitLabel={t('common.close')}
      onFormSubmit={onSubmit}
      onCancel={onCancel}
      bodySx={{ p: 0, mt: 0 }}
      actionSx={
        (noPoints || isError) && { justifyContent: 'space-between', gap: 3 }
      }
      alertMsg={buildAlert({ t, noPoints, symbol, isError })}
    >
      <Box p={3}>
        <Text
          label={
            <Trans
              i18nKey='membership.purchase-status-note'
              components={{
                strong: (
                  <strong
                    style={{
                      color:
                        theme.palette.mode === THEME_MODE.DARK
                          ? 'var(--palette-primary-light)'
                          : 'var(--palette-primary-dark)'
                    }}
                  />
                )
              }}
            />
          }
          color='text.secondary'
        />
      </Box>
      {reqTierNotMet && (
        <PurchaseStatusReq
          tiers={tiers}
          userTier={userTier}
          onCancel={onCancel}
        />
      )}
      <StatusUpgradeList
        tiers={tiersPurchase}
        symbol={symbol}
        t={t}
        disabled={reqTierNotMet}
        onPurchase={onPurchase}
        isProcessing={isProcessing}
      />
    </Popup>
  )
}

export default memo(PurchaseStatus)

const buildAlert = ({ t, isError, noPoints, symbol }) => {
  if (isError) {
    return (
      <CustomAlert
        severity='error'
        desc={t('notification.status-upgrade-purchase-failed')}
        sx={{ py: 0.3 }}
      />
    )
  } else if (noPoints) {
    return (
      <CustomAlert
        severity='warning'
        desc={t('notification.you-do-not-have-enough-to-upgrade', { symbol })}
        sx={{ py: 0.3 }}
      />
    )
  }
  return null
}
